export default __webpack_public_path__ + "static/media/applause.48552444.mp3";